export default {
  ADD_CUSTOM_PALETTE: 'add-custom-palette',
  PALETTE_SETTINGS: 'palette-settings',
  COLOR_PALETTE_SETTINGS: 'color-palette-settings',
  COLOR_SCHEME_SETTINGS: 'color-scheme-settings',
  COLOR_SETTINGS: 'color-settings',
  ITEM_COLOR: 'item-color',
  COLOR_SCHEME: 'color-scheme',
  PRIMARY_BUTTON_COLOR: 'primary-button-color',
  SECONDARY_BUTTON_COLOR: 'secondary-button-color',
};
